import axios from 'axios';

const API_BASE = '/api/market/apiDocs';
const config = require('../config/dev.json');

const craftsCache = new Map();

export const getCraftsData = id => {
    if (id == null) {
        return Promise.reject(new Error("No id provided"));
    }

    if (craftsCache.has(id)) {
        return craftsCache.get(id);
    }

    const origin = window.location.origin;
    const referer = document.referrer;

    const p = axios
        .get(
            `${config.base_URL}${API_BASE}?properties=crafts`,
            {
                headers: {
                    "Origin_URL": origin,
                    "Referer_URL": referer,
                }
            }
        )
        .catch(err => {
            craftsCache.delete(id);
            console.error("getCraftsData failed:", err);
            throw err;
        });

    craftsCache.set(id, p);
    return p;
};
